module.exports = __webpack_public_path__ + "static/media/lucidagrande-webfont.a9e28c97.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/lucidagrande-webfont.otf
// module id = 536
// module chunks = 0